<template>
    <el-row>
        <el-col :span="6">
            <h3 class="text-title">云上数据中心</h3>
        </el-col>
        <el-col :span="2" :offset="13">
            <p>你好!{{this.$store.state.userId}}</p>
        </el-col>
        <el-col :span="2">
            <el-button type="text" style="margin-top: 5px" @click="logout">退出</el-button>
        </el-col>
        <!--<el-col :span="2">-->
            <!--<el-button type="text" @click="logout">sign out</el-button>-->
        <!--</el-col>-->
    </el-row>
</template>

<script>
    export default {
        name: "Header",
        methods: {
            logout: function() {
                this.$cookie.delete('token');
                this.$router.push({path: '/'})
            }
        }
    }
</script>

<style scoped>
    @import '../assets/text-font.css';

</style>